import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';
import { GenesysLoginService } from './login-action/gensys-auth.guard';

@Injectable({
  providedIn: 'root'
})
export class GenesysCloudInterceptor implements HttpInterceptor {

  constructor(private oAuthService: OAuthService, private genesysLoginService: GenesysLoginService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let bearerToken = `Bearer ${ this.oAuthService.getAccessToken() }`
    const clonedRequest = req.clone({
      headers: req.headers.set('AuthorizationGenesys', bearerToken)
    });
    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          // Trigger login popup for Genesys
          this.genesysLoginService.handleNoValidAccessToken(window.location.pathname);
        }
        return throwError(() => error);
      })
    );
  }
}
